import React__default, { useState, useRef } from 'react';
import { FontAwesomeIcon } from '../../../node_modules/@fortawesome/react-fontawesome/index.es.js';
import { faEllipsisV } from '../../../node_modules/@fortawesome/free-solid-svg-icons/index.js';
import { faGrid } from '../../../node_modules/@fortawesome/sharp-solid-svg-icons/index.js';
import styles from './styles.module.scss.js';
import propsToClass from '../../../helpers/propsToClass.js';

/**
 * @description Nimvelo Menu component
 * @props type, size, align, disabled, icon, data, onClick, color
 */
const NvMenu = ({ type = 'list', size = 'standard', align = 'left', disabled = false, icon, data = [], color, itemIconSize, }) => {
    const [isMenuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef(null);
    // FIXME adding/removing event listeners to document feels wonky, plus it doesn't really work with storybook
    const handleClickOutside = (e) => {
        const menu = menuRef.current;
        const clickedElement = e.target;
        if (!menu?.contains(clickedElement)) {
            setMenuOpen(false);
        }
        document.removeEventListener('click', handleClickOutside);
    };
    const toggleDropDown = () => {
        setMenuOpen(!isMenuOpen);
        if (!isMenuOpen)
            document.addEventListener('click', handleClickOutside);
    };
    /**
     * Menu Item Hover logic
     */
    const handleMouseEnter = (e) => {
        const thisElement = e.target;
        if (thisElement.tagName !== 'BUTTON' && thisElement.tagName !== 'A')
            return;
        thisElement.style.backgroundColor = color?.itemHover || '';
    };
    const handleMouseLeave = (e) => {
        const thisElement = e.target;
        thisElement.style.backgroundColor = 'transparent';
    };
    /**
     * Menu Content
     */
    const defaultIcon = type === 'list' ? (React__default.createElement(FontAwesomeIcon, { icon: faEllipsisV })) : (React__default.createElement(FontAwesomeIcon, { icon: faGrid }));
    const menuContent = data.map(item => {
        let itemContent;
        let itemIcon;
        if (item.icon) {
            itemIcon =
                typeof item.icon === 'string' ? (React__default.createElement("img", { className: `${styles.item_icon} ${styles[type]}`, alt: "icon", src: item.icon })) : (React__default.createElement("div", { className: `${styles.item_icon} ${styles[type]}` }, item.icon));
        }
        // render label item
        if (!('onClick' in item) && !('href' in item)) {
            itemContent = (React__default.createElement("div", { className: `${styles.label_item} ${styles[type]} ${styles[align]}`, key: item.label },
                itemIcon,
                React__default.createElement("span", { className: `${styles.item_link} ${styles[type]}` }, item.label)));
        }
        // if item has onClick, render button
        if ('onClick' in item) {
            itemContent = (React__default.createElement("button", { type: "button", className: `${styles.menu_item} ${styles[type]} ${styles[align]}`, key: item.label, onClick: () => {
                    item.onClick();
                    setMenuOpen(false);
                }, onMouseEnter: color?.itemHover ? handleMouseEnter : undefined, onMouseLeave: color?.itemHover ? handleMouseLeave : undefined, onFocus: undefined },
                itemIcon,
                React__default.createElement("span", { className: `${styles.item_link} ${styles[type]}` }, item.label)));
            // else render link
        }
        else if ('href' in item) {
            itemContent = (React__default.createElement("a", { className: `${styles.menu_item} ${styles[type]} ${styles[align]}`, key: item.label, href: item.href, onMouseEnter: color?.itemHover ? handleMouseEnter : undefined, onMouseLeave: color?.itemHover ? handleMouseLeave : undefined, onFocus: undefined },
                itemIcon,
                React__default.createElement("span", { className: `${styles.item_link} ${styles[type]}` }, item.label)));
        }
        return itemContent;
    });
    return (React__default.createElement("div", { className: propsToClass(`${styles.wrapper} ${styles[size]} ${styles[align]}`, [[styles.disabled, disabled]]), ref: menuRef, style: { '--item-icon-size': itemIconSize } },
        React__default.createElement("button", { type: "button", onClick: toggleDropDown, className: `${styles.icon} ${styles[align]}` }, icon || defaultIcon),
        React__default.createElement("div", { className: `${styles.menu} ${isMenuOpen && styles.show} ${styles[align]} ${styles[type]}`, style: color && { backgroundColor: color?.background, color: color?.text } }, menuContent)));
};

export { NvMenu, NvMenu as default };
//# sourceMappingURL=component.js.map
